/**
 * iframe 安全配置文件
 * 用於集中管理允許的父頁面域名和安全策略
 */

// 根據環境變量或默認值配置允許的父頁面域名
const getAllowedParentOrigins = () => {
  // 開發環境
  if (process.env.NODE_ENV === 'development') {
    return [
      'http://localhost:8080',
      'http://localhost:8081',
      'http://127.0.0.1:8080',
      'http://127.0.0.1:8081',
      'http://localhost:3001',
      // 可以添加更多開發環境域名
    ]
  }
  
  // 生產環境
  if (process.env.NODE_ENV === 'production') {
    return [
      // ⚠️ 重要：請替換為實際的生產環境父頁面域名
      'https://your-parent-domain.com',
      'https://admin.your-parent-domain.com',
      // 可以添加更多生產環境域名
    ]
  }
  
  // 默認（測試環境等）
  return [
    'http://localhost:8080',
    'http://127.0.0.1:8080',
    'http://localhost:3001',
  ]
}

// CSP frame-ancestors 配置
const getFrameAncestors = () => {
  if (process.env.NODE_ENV === 'development') {
    return "'self' http://localhost:* http://127.0.0.1:* http://localhost:3001"
  }
  
  if (process.env.NODE_ENV === 'production') {
    // ⚠️ 重要：請替換為實際的生產環境父頁面域名
    return "https://your-parent-domain.com https://admin.your-parent-domain.com"
  }
  
  return "'self' http://localhost:* http://localhost:3001 http://127.0.0.1:*"
}

// 導出配置
export const securityConfig = {
  allowedParentOrigins: getAllowedParentOrigins(),
  frameAncestors: getFrameAncestors(),
  
  // 其他安全配置
  messageTimeout: 60000, // postMessage 消息有效期（毫秒）
  enableSignatureVerification: true, // 是否啟用簽名驗證
  
  // 日誌配置
  enableSecurityLogs: process.env.NODE_ENV === 'development', // 開發環境顯示安全日誌
}

export default securityConfig

